import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { OPEN_PAGE_NAVIGATION, NONE } from '../../modules/constants';
import { track } from '../../modules/tracking';

const ACTIVE_CLASS = 'active';

/**
 * Button for mobile navigation.
 *
 * @function
 * @param       {boolean} inList           If we are already in a list, this will be true and force the omission of the opening ul tag.
 * @param       {string} text              The text of the link.
 * @param       {string} className         An optional class to add to the existing component class attribute.
 * @param       {function} setOpenMobileMenu useState function to set if the menu is opened using the burger menu button for mobile
 * @param       {boolean} openMobileMenu   Is true if the menu opener button clicked was the burger menu button for mobile.
 * @constructor
 */
function MobileNavigation({
    inList,
    text,
    className,
    setOpenMobileMenu,
    openMobileMenu
}) {
    const [currentClassName, setCurrentClassName] = useState('');
    function Button() {
        useLayoutEffect(() => {
            const newClassName = [
                className,
                openMobileMenu ? ACTIVE_CLASS : null
            ].join(' ');

            if (newClassName !== currentClassName) {
                setCurrentClassName(newClassName);
            }
        }, [openMobileMenu]);

        return (
            <button
                title={OPEN_PAGE_NAVIGATION}
                onClick={() => {
                    setOpenMobileMenu(!openMobileMenu);
                    track('Mobile menu opener click')();
                }}
                className={currentClassName}
            >
                {text}
            </button>
        );
    }
    if (inList) {
        return (
            <li role={NONE}>
                <Button />
            </li>
        );
    }

    return <Button />;
}

export { MobileNavigation };

MobileNavigation.propTypes = {
    inList: PropTypes.bool,
    text: PropTypes.string,
    className: PropTypes.string,
    openMobileMenu: PropTypes.bool,
    setOpenMobileMenu: PropTypes.func
};
